var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"app-main"},[(_vm.canRenderContent)?_c('router-view',{directives:[{name:"show",rawName:"v-show",value:(!_vm.iframeShowUrl),expression:"!iframeShowUrl"}]}):_vm._e(),(_vm.iframeShowUrl)?_c('iframe',{attrs:{"src":_vm.iframeShowUrl,"id":"contentIframe","frameborder":"0"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }